<div class="dashboard-layout">
  <main class="feed-section">
    <div class="feed-header">
      <h3>Сообщения о бронировании</h3>
      <span class="total">Всего: {{ totalBookings }}</span>
    </div>

    <div class="feed-list" *ngIf="dayGroups.length > 0; else emptyState">
      <div class="day-group" *ngFor="let group of dayGroups" [id]="'day-' + group.date">
        <div class="day-header">
          <span class="day-label">{{ group.label + ' ' }}</span>
          <span class="day-count">{{ group.bookings.length }} шт.</span>
        </div>
        <app-booking-card
          *ngFor="let b of group.bookings"
          [booking]="b"
          (open)="openBooking($event)"
        />
      </div>
    </div>

    <ng-template #emptyState>
      <div class="empty">
        <p>Нет бронирований за выбранный месяц</p>
      </div>
    </ng-template>
  </main>

  <aside class="calendar-sidebar">
    <app-booking-calendar
      [currentDate]="currentMonth"
      [counts]="countsMap"
      [selectedDateStr]="selectedDateStr"
      (dateSelected)="onDateSelected($event)"
      (monthChanged)="onMonthChanged($event)"
    />
  </aside>
</div>
